module.exports = __webpack_public_path__ + "static/img/image_empty2_large.778875b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_empty2_large.png
// module id = 250
// module chunks = 1